import { render } from "./ProdutoRepeticaoInicio.vue?vue&type=template&id=4954b85a&scoped=true"
import script from "./ProdutoRepeticaoInicio.vue?vue&type=script&lang=js"
export * from "./ProdutoRepeticaoInicio.vue?vue&type=script&lang=js"

import "./ProdutoRepeticaoInicio.vue?vue&type=style&index=0&id=4954b85a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4954b85a"]])

export default __exports__